import { render } from "./RefCompo.vue?vue&type=template&id=1bb8a602&scoped=true"
import script from "./RefCompo.vue?vue&type=script&lang=js"
export * from "./RefCompo.vue?vue&type=script&lang=js"

import "./RefCompo.vue?vue&type=style&index=0&id=1bb8a602&scoped=true&lang=css"

import exportComponent from "D:\\Dev\\VueJS\\jobapply-TH\\jobapplyvuejs\\Vue\\vue-crud-netcoreapi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb8a602"]])

export default __exports__